import * as React from 'react';

function Acca(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 16" {...props}>
      <g clipPath="url(#prefix__clip0_5008_5632)">
        <path d="M16.168 16H0L2.832 0H19l-2.832 16z" fill="#00FFB7" />
        <path
          d="M4.026 14.062l1.412-1.19.832-4.72-1.393 1.172-.85 4.738zM6.134 12.284l1.502-1.27.833-4.712-1.502 1.271-.833 4.711zM8.92 2.96l1.476 1.724-1.222 1.032-.832 4.72.353-.303 3.664-3.084 1.412 1.733L14.8 2.96h-5.88z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_5008_5632">
          <path fill="white" d="M0 0h19v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Acca;
